import React from 'react';

import RouteIfRights from 'pages/router/RouteIfRights';

import Form from './Form';
import Confirmation from './Confirmation';

const paths = {
  form: '/ecom/provisioning',
  confirmation: '/ecom/provisioning/confirmation',
};

export default [
  <RouteIfRights exact path={paths.form} key={paths.form} component={Form} rights="ecom" />,
  <RouteIfRights
    exact
    path={paths.confirmation}
    key={paths.confirmation}
    component={Confirmation}
    rights="ecom"
  />,
];

export { paths };
